module.exports = __webpack_public_path__ + "static/img/03.25830256.png";